import { render, staticRenderFns } from "./ShowRouteDetails.vue?vue&type=template&id=5a12d0f0&scoped=true"
import script from "./ShowRouteDetails.vue?vue&type=script&lang=js"
export * from "./ShowRouteDetails.vue?vue&type=script&lang=js"
import style0 from "./ShowRouteDetails.vue?vue&type=style&index=0&id=5a12d0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12d0f0",
  null
  
)

export default component.exports